import { createSlice } from '@reduxjs/toolkit';
import { defaultHouseBillingCurrencySlice } from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.types';
import {
    fetchHouseBillingCurrencyOptions,
    saveHouseBillingCurrency,
} from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.actions';

const houseBillingCurrencySlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchHouseBillingCurrencyOptions.pending, (slice) => {
            slice.loading = true;
        });
        builder.addCase(fetchHouseBillingCurrencyOptions.fulfilled, (slice, { payload }) => {
            slice.availableCurrencies = payload;
            slice.loading = false;
        });
        builder.addCase(fetchHouseBillingCurrencyOptions.rejected, (slice) => {
            slice.loading = false;
        });

        builder.addCase(saveHouseBillingCurrency.pending, (slice) => {
            slice.wasSaveSuccessful = undefined;
        });
        builder.addCase(saveHouseBillingCurrency.fulfilled, (slice) => {
            slice.wasSaveSuccessful = true;
        });
        builder.addCase(saveHouseBillingCurrency.rejected, (slice) => {
            slice.wasSaveSuccessful = false;
        });
    },
    initialState: defaultHouseBillingCurrencySlice,
    name: 'houseBillingCurrency',
    reducers: {},
});

export const { reducer: houseBillingCurrencyReducer } = houseBillingCurrencySlice;
